
const iptaliade = () => {
    return (
        <>
            <div className="mss">
                <p>
                    <p>
                        GENEL:
                    </p>
                    <p>
                        Kullanmakta olduğunuz web sitesi üzerinden elektronik ortamda sipariş verdiğiniz takdirde, size sunulan ön bilgilendirme formunu ve mesafeli satış sözleşmesini kabul etmiş sayılırsınız.
                    </p>
                    <p>
                        Alıcılar, satın aldıkları paketin satış ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği (RG:27.11.2014/29188) hükümleri ile yürürlükteki diğer yasalara tabidir.
                    </p> 
                    <p>
                        Satın alınan her bir paket, Hizmet başlama gün sınırına göre aktif olur.  
                    </p>
                    <p>
                        Satın alınan paket, sözleşme şartlarında belirtilen niteliklere uygun, ve satış paket sözleşmesi ile teslim edilmek zorundadır.
                    </p>
                    <p>
                        Satın alınan paketin satılmasının imkansızlaşması durumunda, satıcı bu durumu öğrendiğinden itibaren 3 gün içinde yazılı olarak alıcıya bu durumu bildirmek zorundadır. 14 gün içinde de toplam bedel Alıcı’ya iade edilmek zorundadır.
                    </p>
                    <p>
                        SATIN ALINAN PAKET BEDELİ ÖDENMEZ İSE:
                    </p>
                    <p>
                        Alıcı, satın aldığı paket hizmetinin bedelini ödemez veya banka kayıtlarında iptal ederse, Satıcının paket hizmeti yerine getirme yükümlülüğü sona erer.

                    </p>
                    <p>

                        KREDİ KARTININ YETKİSİZ KULLANIMI İLE YAPILAN ALIŞVERİŞLER:
                    </p>
                    Ürün teslim edildikten sonra, alıcının ödeme yaptığı kredi kartının yetkisiz kişiler tarafından haksız olarak kullanıldığı tespit edilirse ve satılan paket bedeli ilgili banka veya finans kuruluşu tarafından Satıcı'ya ödenmez ise, Alıcı, sözleşme konusu ürünü 3 gün içerisinde vergilendirme gideri ALICI’ya ait olacak şekilde SATICI’ya iade etmek zorundadır.
                </p>
                <p> 
                    ÖNGÖRÜLEMEYEN SEBEPLERLE ÜRÜN SÜRESİNDE TESLİM EDİLEMEZ İSE:
                </p>
                <p>
                    Satıcı’nın öngöremeyeceği mücbir sebepler oluşursa ve ürün süresinde teslim edilemez ise, durum Alıcı’ya bildirilir. Alıcı, siparişin iptalini, ürünün benzeri ile değiştirilmesini veya engel ortadan kalkana dek teslimatın ertelenmesini talep edebilir. Alıcı siparişi iptal ederse; ödemeyi nakit ile yapmış ise iptalinden itibaren 14 gün içinde kendisine nakden bu ücret ödenir. Alıcı, ödemeyi kredi kartı ile yapmış ise ve iptal ederse, bu iptalden itibaren yine 14 gün içinde ürün bedeli bankaya iade edilir, ancak bankanın alıcının hesabına 2-3 hafta içerisinde aktarması olasıdır.

                </p>
                <p> 
                    ALICININ SÖZLEŞME İÇERİĞİNİ KONTROL ETME YÜKÜMLÜLÜĞÜ:
                </p>
                <p>
                    Alıcı, sözleşme konusu mal/hizmeti teslim almadan önce sözleşme içeriğini okuyacak ; ALICI , Cayma hakkı kullanılacaksa hizmet kullanılmamış olmalıdır. Ürünle birlikte Fatura da iade edilmelidir.

                </p>
                <p> 
                    CAYMA HAKKI:
                </p>
                <p>
                    ALICI; satın aldığı paketin kendisine veya gösterdiği adresteki kişi/kuruluşa teslim tarihinden itibaren 3 (üç) gün içerisinde, SATICI’ya aşağıdaki iletişim bilgileri üzerinden bildirmek şartıyla hiçbir hukuki ve cezai sorumluluk üstlenmeksizin ve hiçbir gerekçe göstermeksizin malı reddederek sözleşmeden cayma hakkını kullanabilir.
                </p>
                <p> 
                    SATICININ CAYMA HAKKI BİLDİRİMİ YAPILACAK İLETİŞİM BİLGİLERİ:
                </p>
                <p>
                    ŞİRKET
                </p>
                <p>
                    ADI/UNVANI: MOBIL ASSISTANCE SERVİS HİZMETLERİ DENETİM DANIŞMANLIK TİCARET LTD.ŞTİ 
                </p>
                <p>
                    ADRES:Gevhernesibe, Alpay Sk. Lifos Tower İş Merkezi B/Blok No : 17/7-8, 38010</p>
                <p>
                    EPOSTA:info@mobilassistance.com</p>
                <p>
                    TEL:0850 255 0203</p>
                <p>  
                    CAYMA HAKKININ SÜRESİ:</p>
                <p>

                    Alıcı, satın aldığı eğer bir hizmet ise, bu 3 günlük süre sözleşmenin imzalandığı tarihten itibaren hizmet başlama gün sınırına göre  başlar. Cayma hakkı süresi sona ermeden önce, tüketicinin onayı ile hizmetin ifasına başlanan hizmet sözleşmelerinde cayma hakkı kullanılamaz.
                </p>
                <p>
                    Cayma hakkının kullanımından kaynaklanan masraflar ALICI ya aittir.
                </p>
                <p>
                    Cayma hakkının kullanılması için 3 (üç) günlük süre içinde SATICI' ya iadeli taahhütlü posta, faks veya eposta ile yazılı bildirimde bulunulması ve ürünün işbu sözleşmede düzenlenen "Cayma Hakkı Kullanılamayacak Ürünler" hükümleri çerçevesinde kullanılmamış olması şarttır.
                </p>
                <p> 
                    CAYMA HAKKININ KULLANIMI:
                </p>
                <p>
                    3. kişiye veya ALICI’ ya teslim edilen ürünün faturası, (İade edilmek istenen ürünün faturası kurumsal ise, iade ederken kurumun düzenlemiş olduğu iade faturası ile birlikte gönderilmesi gerekmektedir. Faturası kurumlar adına düzenlenen sipariş iadeleri İADE FATURASI kesilmediği takdirde tamamlanamayacaktır.)
                </p>
                <p>
                    İade formu, İade edilecek ürünlerin kutusu, ambalajı, varsa standart aksesuarları ile birlikte eksiksiz ve hasarsız olarak teslim edilmesi gerekmektedir.
                </p>
                <p> 
                    İADE KOŞULLARI:
                </p>
                <p>
                    SATICI, cayma bildiriminin kendisine ulaşmasından itibaren en geç 10 günlük süre içerisinde toplam bedeli ve ALICI’yı borç altına sokan belgeleri ALICI’ ya iade etmek ve 20 günlük süre içerisinde malı iade almakla yükümlüdür.
                </p>
                <p>
                    ALICI’ nın kusurundan kaynaklanan bir nedenle malın değerinde bir azalma olursa veya iade imkânsızlaşırsa ALICI kusuru oranında SATICI’ nın zararlarını tazmin etmekle yükümlüdür. Ancak cayma hakkı süresi içinde malın veya ürünün usulüne uygun kullanılması sebebiyle meydana gelen değişiklik ve bozulmalardan ALICI sorumlu değildir.
                </p>
                <p>
                    Cayma hakkının kullanılması nedeniyle SATICI tarafından düzenlenen kampanya limit tutarının altına düşülmesi halinde kampanya kapsamında faydalanılan indirim miktarı iptal edilir.
                </p> 
                <p> 
                    TEMERRÜT HALİ VE HUKUKİ SONUÇLARI
                </p>
                <p>
                    ALICI, ödeme işlemlerini kredi kartı ile yaptığı durumda temerrüde düştüğü takdirde, kart sahibi banka ile arasındaki kredi kartı sözleşmesi çerçevesinde faiz ödeyeceğini ve bankaya karşı sorumlu olacağını kabul, beyan ve taahhüt eder. Bu durumda ilgili banka hukuki yollara başvurabilir; doğacak masrafları ve vekâlet ücretini ALICI’dan talep edebilir ve her koşulda ALICI’nın borcundan dolayı temerrüde düşmesi halinde, ALICI, borcun gecikmeli ifasından dolayı SATICI’nın uğradığı zarar ve ziyanını ödeyeceğini kabul eder.
                </p>
                <p> 
                    ÖDEME VE TESLİMAT
                </p>
                <p>
                    Banka Havalesi veya EFT (Elektronik Fon Transferi) yaparak, ............, ........., bankası hesaplarımızdan (TL) herhangi birine yapabilirsiniz.
                </p>
                <p>
                    Sitemiz üzerinden kredi kartlarınız ile, Her türlü kredi kartınıza online ödeme imkânlarından yararlanabilirsiniz. Online ödemelerinizde siparişiniz sonunda kredi kartınızdan tutar çekim işlemi gerçekleşecektir.
                </p>
            </div>
        </>
    );
};

export default iptaliade;